import { useState } from "react";
import { axiosInstance } from "../../config/api";
import { toast } from "sonner";
import { Lock, LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SuperadminUnlockScreen({ user, onUnlocked, onLogout }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    try {
      await axiosInstance.post("/auth/superadmin/unlock", { unlock_code: code.trim() });
      toast.success("Kunci dibuka! Selamat datang, Superadmin 🎉");
      onUnlocked();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Kod keselamatan tidak sah");
      setCode("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, #1a1c3d 0%, #2B2E6B 55%, #3a2d5e 100%)" }}
      data-testid="superadmin-unlock-screen"
    >
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 text-center">
        <div
          className="mx-auto mb-5 w-20 h-20 rounded-full flex items-center justify-center"
          style={{ background: "linear-gradient(135deg, #FFC93C, #FF6B6B)", boxShadow: "0 0 24px rgba(255,107,107,0.45)" }}
        >
          <Lock size={36} color="#fff" />
        </div>
        <h1 className="text-2xl font-black text-gray-800 mb-2">Akaun Superadmin Dikunci</h1>
        <p className="text-sm text-gray-500 mb-6">
          Hai <span className="font-bold text-gray-700">{user?.name || "Superadmin"}</span>, sistem ini baru dipulihkan
          dari backup. Sila masukkan kod keselamatan untuk membuka akses penuh.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <ShieldCheck className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-red-400" />
            <input
              type="password"
              inputMode="numeric"
              autoFocus
              data-testid="unlock-code-input"
              className="w-full pl-12 pr-4 py-4 border-3 border-red-200 rounded-2xl focus:border-red-400 focus:ring-4 focus:ring-red-100 transition-all outline-none bg-white font-bold text-gray-700 placeholder-gray-400 text-center tracking-widest"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Kod keselamatan"
              required
            />
          </div>

          <Button
            type="submit"
            disabled={loading || !code.trim()}
            data-testid="unlock-submit-btn"
            className="w-full py-4 font-black text-lg rounded-2xl shadow-lg transition-all hover:shadow-xl hover:-translate-y-1"
            style={{ background: "linear-gradient(90deg, #FFC93C, #FFD34F)", color: "#2B2E6B" }}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="w-5 h-5 border-3 border-white/30 border-t-white rounded-full animate-spin" />
                Mengesahkan...
              </span>
            ) : "Buka Kunci"}
          </Button>
        </form>

        <button
          type="button"
          onClick={onLogout}
          data-testid="unlock-logout-btn"
          className="mt-5 text-sm text-gray-400 hover:text-gray-600 font-bold hover:underline transition-colors flex items-center justify-center gap-1 mx-auto"
        >
          <LogOut size={14} /> Log Keluar
        </button>
      </div>
    </div>
  );
}
